import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_AlertMaintenance } from "../shared/data.service";

import { wsAlertMaintenanceBroadcastAlertAddParm } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddSchoolInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertTargetInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddInsertParm } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";
import { wsAlertMaintenanceBroadcastAlertAddInsertSchoolInfo } from "../shared/wsAlertMaintenanceBroadcastAlertInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";

@Component({
	selector: "app-root",
	templateUrl: "./addbroadcastalert.component.html",
	styleUrls: ["./addbroadcastalert.component.css"],
	providers: [ConfirmationService],
})
export class AddBroadcastAlertComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_AlertMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;
	public isShowInfo: boolean = false;

	public UserID: number;
	public UserLevelID: number;

	public BroadcastAlertData: wsAlertMaintenanceBroadcastAlertAddInfo;
	public lstTargetItems: wsAlertMaintenanceBroadcastAlertTargetInfo[] = [];
	public SelectedTarget: wsAlertMaintenanceBroadcastAlertTargetInfo;
	public lstSchoolItems: wsAlertMaintenanceBroadcastAlertAddSchoolInfo[] = [];
	public lstSchoolItemsChecked: wsAlertMaintenanceBroadcastAlertAddSchoolInfo[] = [];

	public rMessage: string = "";
	public rStartDate: Date = null;
	public rEndDate: Date = null;

	//	DataTable page counts
	public pagefirst: number = 0;
	public pagerows: number = 5;

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;

		let parm: wsAlertMaintenanceBroadcastAlertAddParm = {
			UserID: this.UserID,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceBroadcastAlertAddDataGet(parm).subscribe((data) => this.AlertMaintenanceBroadcastAlertAddDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertAddDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertAddDataGet_Complete(data: any) {
		this.BroadcastAlertData = data;

		this.lstTargetItems = this.BroadcastAlertData.TargetItems;
		this.lstSchoolItems = this.BroadcastAlertData.SchoolItems;
		this.rMessage = this.BroadcastAlertData.Message;

		if (this.BroadcastAlertData.StartDate == null) {
			this.rStartDate = null;
		} else {
			this.rStartDate = new Date(this.BroadcastAlertData.StartDate); // Must do new for this to work
		}

		if (this.BroadcastAlertData.EndDate == null) {
			this.rEndDate = null;
		} else {
			this.rEndDate = new Date(this.BroadcastAlertData.EndDate); // Must do new for this to work
		}

		//
		//	Select Default Target
		//
		this.SelectedTarget = this.lstTargetItems[0];

		this.lstTargetItems.forEach((item) => {
			if (item.BroadcastAlertTargetID == this.BroadcastAlertData.BroadcastAlertTargetID) {
				this.SelectedTarget = item;
			}
		});

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStartDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onStartDateChange(val) {
		this.rStartDate = val;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onEndDateChange
	//
	//-----------------------------------------------------------------------------------------------------
	onEndDateChange(val) {
		this.rEndDate = val;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTargetChange
	//
	//-----------------------------------------------------------------------------------------------------
	onTargetChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleInfo() {
		this.isShowInfo = !this.isShowInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleFilter
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleFilter(e: any) {
		this.lstSchoolItemsChecked = [];
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onUpdate() {
		this.ErrorMessage = "";

		//
		// Validate Message
		//
		if (this.rMessage.length < 1) {
			this.ErrorMessage = "Message must be entered.";
			return;
		}

		//
		// Validate Dates
		//
		if (this.rStartDate == null || this.rEndDate == null) {
			this.ErrorMessage = "Start Date and End Date must be entered.";
			return;
		} else {
			if (this.rStartDate.getFullYear() < 1753 || this.rEndDate.getFullYear() < 1753) {
				// SQL Does not support dates < 1753
				this.ErrorMessage = "Start Date and End Date must be greater then 1/1/1753.";
				return;
			}

			if (this.rEndDate < this.rStartDate) {
				this.ErrorMessage = "End Date cannot be less then Start Date.";
				return;
			}
		}

		//
		// Validate School List
		//
		if (this.lstSchoolItemsChecked.length == 0) {
			this.ErrorMessage = "You must select at least one school.";
			return;
		}

		//
		// Do the ADD
		//
		let lstSelectedSchools: wsAlertMaintenanceBroadcastAlertAddInsertSchoolInfo[] = [];

		this.lstSchoolItemsChecked.forEach((item) => {
			lstSelectedSchools.push({ SchoolID: item.SchoolID });
		});

		let parm: wsAlertMaintenanceBroadcastAlertAddInsertParm = {
			UserID: this.UserID,
			BroadcastAlertTargetID: this.SelectedTarget.BroadcastAlertTargetID,
			StartDate: this.rStartDate,
			EndDate: this.rEndDate,
			Message: this.rMessage,
			SchoolItems: lstSelectedSchools,
		};

		this.isBusy = true;
		this.dataService.AlertMaintenanceBroadcastAlertInsert(parm).subscribe((data) => this.AlertMaintenanceBroadcastAlertInsert_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AlertMaintenanceBroadcastAlertInsert_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AlertMaintenanceBroadcastAlertInsert_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
